<template>
  <div class="container py-4">
    <h2 class="mb-4 text-center text-primary">Generate QR for Student Items</h2>
    <div class="table-responsive">
      <p class="text-end text-muted">
  Total Student Items: {{ totalCount }}
</p>

      <table class="table table-striped table-hover table-bordered">
        <thead class="table-primary text-center">
          <tr>
            <th>ID</th>
            <th>Student</th>
            <th>Subject</th>
            <th>Teacher</th>
            <th>Payment Type</th>
            <th>Amount</th>
            <th>Payment Date</th>
            <th>Expiration Date</th>
            <th>View QR</th>
            <th>Status</th>
            <th>QR Generate</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in studentItems" :key="item.id" class="text-center">
            <td>{{ item.id }}</td>
            <td>{{ item.student.first_name }}</td>
            <td>{{ item.subject.name }}</td>
            <td>{{ item.teacher.user.first_name }}</td>
            <td>{{ item.pay_type.payment_type }}</td>
            <td>{{ item.amount }}</td>
            <td>{{ item.payment_date }}</td>
            <td>{{ item.exp_date }}</td>
            <td>
              <button
                @click="viewStudentCode(item.id)"
                class="btn btn-outline-primary btn-sm d-flex align-items-center"
                data-bs-toggle="modal"
                data-bs-target="#viewStudentCodeModal"
              >
                <i class="bi bi-qr-code me-1"></i> View
              </button>
            </td>
            <td>
              <span
                :class="{
                  'badge bg-success': item.qr_status.id === 2,
                  'badge bg-warning text-dark': item.qr_status.id === 1,
                  'badge bg-danger': item.qr_status.id === 3,
                }"
              >
                {{ item.qr_status.name }}
              </span>
            </td>
            <td>
              <button
                @click="generateStudentCode(item.id)"
                class="btn btn-outline-primary btn-sm d-flex align-items-center"
                data-bs-toggle="modal"
                data-bs-target="#generateStudentCodeModal"
              >
                <i class="bi bi-qr-code me-1"></i> Generate
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- Loading Spinner -->
    <div v-if="loading" class="d-flex justify-content-center my-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <!-- No Data Found Message -->
    <div v-else-if="studentItems.length === 0" class="text-center my-4">
      <p class="text-muted fs-5">No data found</p>
    </div>
    </div>

    <div class="d-flex justify-content-center mt-4">
  <button class="btn btn-outline-primary me-2" :disabled="currentPage === 1" @click="goToPage(currentPage - 1)">
    Previous
  </button>
  <span class="align-self-center">Page {{ currentPage }} of {{ totalPages }}</span>
  <button class="btn btn-outline-primary ms-2" :disabled="currentPage === totalPages" @click="goToPage(currentPage + 1)">
    Next
  </button>
</div>


    <!-- Modal View -->
    <div
      class="modal fade"
      id="viewStudentCodeModal"
      tabindex="-1"
      aria-labelledby="viewStudentCodeModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white">
            <h1 class="modal-title fs-5" id="viewStudentCodeModalLabel">
              View Student QR
            </h1>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <ViewStudentCode :student="selectedStudentCodeView" />
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Generate -->
    <div
      class="modal fade"
      id="generateStudentCodeModal"
      tabindex="-1"
      aria-labelledby="generateStudentCodeModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white">
            <h1 class="modal-title fs-5" id="generateStudentCodeModalLabel">
              Generate Student QR
            </h1>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <GenerateStudentCode :student="selectedStudentCode" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import GenerateStudentCode from "@/components/Student/GenerateStudentCode.vue";
import ViewStudentCode from "@/components/Student/ViewStudentCode.vue";

export default {
  components: {
    ViewStudentCode,
    GenerateStudentCode,
  },
  data() {
    return {
      loading: true, // Initial state
      studentItems: [],
      selectedStudentCode: null,
      selectedStudentCodeView: null,
      currentPage: 1,
    totalPages: 1,
    totalCount: 0,  // <-- new total count
    };
  },
  mounted() {
    this.fetchStudentItems();
  },
  methods: {
    // async fetchStudentItems() {
    //   this.loading = true;
    //   try {
    //     const response = await axios.get("/get-all-student-items");
    //     this.studentItems = response.data;
    //   } catch (error) {
    //     console.error("Error fetching student items:", error.message);
    //   } finally {
    //     this.loading = false;
    //   }
    // },

     async fetchStudentItems(page = 1) {
    this.loading = true;
    try {
      const response = await axios.get(`/get-all-student-items?page=${page}`);
      const items = response.data.items;  // <-- this is where paginated data lives
    this.studentItems = items.data;
      this.currentPage = items.current_page;
      this.totalPages = items.last_page;
       this.totalCount = response.data.total_count;
    } catch (error) {
      console.error("Error fetching student items:", error.message);
    } finally {
      this.loading = false;
    }
  },
  goToPage(page) {
    if (page >= 1 && page <= this.totalPages) {
      this.fetchStudentItems(page);
    }
  },
    async generateStudentCode(id) {
      try {
        const response = await axios.get(`/generate-student-code-by-id/${id}`);
        this.selectedStudentCode = response.data;
        await this.fetchStudentItems();
      } catch (error) {
        console.error("Error generating student code:", error.message);
        this.selectedStudentCode = null;
      }
    },
    async viewStudentCode(id) {
      try {
        const response = await axios.get(`/get-student-code-by-id/${id}`);
        this.selectedStudentCodeView = response.data;
      } catch (error) {
        console.error("Error viewing student code:", error.message);
        this.selectedStudentCodeView = null;
      }
    },
  },
};
</script>

<style scoped>
.table th,
.table td {
  vertical-align: middle;
}
.modal-header {
  border-bottom: none;
}
</style>
